import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const exportAll = () =>
  http.get(API_ENDPOINTS.agentExport, { responseType: 'blob' });

const AgentService = {
  exportAll,
};

export default AgentService;
